import { Button, Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import moment, { Moment } from "moment";
import React, { useCallback, useState } from "react";

import { useAddOwnerFlow } from "./AddOwnerFlowContext";
import { useCreateLease } from "./useCreateLease";

export function CreateNewLeaseDialog() {
    const {
        box,
        selectedOwnerId,
        openNewLeaseDialog,
        setOpenNewLeaseDialog,
        onOwnerAdded,
    } = useAddOwnerFlow();
    const [leaseStartDate, setLeaseStartDate] = useState<Moment | null>(moment());
    const [leaseEndDate, setLeaseEndDate] = useState<Moment | null>(null);
    const { createLease, loading } = useCreateLease(box.id);

    const handleCreateLease = useCallback(() => {
        if (!selectedOwnerId || !leaseStartDate) return;
        createLease(
            selectedOwnerId,
            leaseStartDate,
            leaseEndDate,
            () => {
                setOpenNewLeaseDialog(false);
                onOwnerAdded();
            },
        );
    }, [
        createLease,
        selectedOwnerId,
        leaseStartDate,
        leaseEndDate,
        onOwnerAdded,
        setOpenNewLeaseDialog,
    ]);

    const handleClose = useCallback(() => {
        setOpenNewLeaseDialog(false);
    }, [setOpenNewLeaseDialog]);

    return (
        <Dialog open={openNewLeaseDialog} onClose={handleClose}>
            <DialogTitle>New Lease</DialogTitle>
            <DialogContent>
                <form
                    onSubmit={e => {
                        e.preventDefault();
                    }}
                >
                    <DatePicker
                        label="Start Date"
                        value={leaseStartDate}
                        variant="dialog"
                        onChange={date => setLeaseStartDate(date)}
                        format="YYYY/MM/DD"
                    />
                    <DatePicker
                        label="End Date"
                        value={leaseEndDate}
                        variant="dialog"
                        onChange={date => setLeaseEndDate(date)}
                        format="YYYY/MM/DD"
                    />
                    <Button
                        disabled={loading}
                        onClick={handleCreateLease}
                    >
                        Submit
                    </Button>
                </form>
            </DialogContent>
        </Dialog>
    );
}
